import { popperGenerator, defaultModifiers } from '@popperjs/core/lib/popper-lite';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow';
import offsetModifier from '@popperjs/core/lib/modifiers/offset';
import arrowModifier from '@popperjs/core/lib/modifiers/arrow';
import hideModifier from '@popperjs/core/lib/modifiers/hide';
import { padding, fit } from './utils';
export const createPopper = popperGenerator({
    defaultModifiers: [...defaultModifiers, preventOverflow, offsetModifier, arrowModifier, hideModifier],
});
export const arrow = {
    name: 'arrow',
    options: {
        padding: 2,
    },
};
export const offset = {
    name: 'offset',
    options: {
        offset: [0, padding],
    },
};
export const overflow = (containerEl) => ({
    name: 'preventOverflow',
    options: {
        boundary: containerEl,
    },
});
export const adaptiveDirection = (containerEl, directionEl) => ({
    name: 'direction',
    enabled: true,
    phase: 'beforeRead',
    fn({ state }) {
        state.placement = fit({
            containerEl,
            controlEl: state.elements.reference,
            tooltipEl: state.elements.popper,
            directionEl,
        });
    },
});
export const silent = [offset, { name: 'eventListeners', enabled: false }, { name: 'computeStyles', enabled: false }];
//# sourceMappingURL=popper.js.map